import React,{useEffect} from "react";
import {useParams} from "react-router-dom";
import './styles.css'
import PhotoSwipeGFlex from "./PhotoSwipeGFlex";
import useSharedDocHeader from "./DocHeaderHook";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import 'photoswipe/dist/photoswipe.css';
import ErrorBoundary from "./ErrorBoundry";
import {  useQuery } from 'react-query';
import { useTranslation } from "react-i18next";

const categoryQuery = (id) => ({
  queryKey: ['category',id],
  queryFn: async () => fetch('/data/' + id + '.json'
  ,{
    headers : { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }).then(res =>
    res.json()
  ),option:{staleTime:1000*60*5}
})

export const loader =
  (queryClient) =>
  async ({ params }) => {
    const query = categoryQuery(params.catId);
console.log("categoryLoader",params.catId);
    // ⬇️ return data or fetch it
    return (
      queryClient.getQueryData(query.queryKey) ??
      (await queryClient.fetchQuery(query))
    )
  }

export default function CategoryMain() {
  const {doSetTitleKey,doSetMetaDescKey} = useSharedDocHeader();
  const { t } = useTranslation('categoryLabel');
  const newId = useParams().catId;
  
  useEffect(() => {
    document.title = 'Nora Vest, ' + t("categoryLabel:CATEGORY_LABEL_" +newId);
  }, []);


  const { isLoading, isSuccess,error, data } = useQuery(categoryQuery(newId));

  if (isLoading){ 
    return 'Loading...';
  }

  if (error){ 
    return 'An error has occurred: ' + error.message;
  }

  const outer = {
    border: '0',
    color:'black',
    fontSize: '25px' ,
    textAlign: 'center',
    fontWeight: 'bold',
    flexGrow :1,
  };

  if (isSuccess){
    doSetMetaDescKey("categoryMetaDesc:" + data.metaDescKey);
    doSetTitleKey("categoryLabel:" + data.labelKey);
    document.title = 'Nora Vest, ' + t("categoryLabel:" + data.labelKey);
    return (
      <Grid2 height="100vh" display="flex" flexDirection="column" sx={outer}>
        <ErrorBoundary>
          <PhotoSwipeGFlex images={data}/>
        </ErrorBoundary>
      </Grid2>
    )
  }
}